<template>
    <div id="nav">
        <div class="nav-wrap" v-bind:class="{show:show}">
            <div class="nav-links">  
                <router-link v-on:click.native="show = !show" to="/">Home</router-link>
                <router-link v-on:click.native="show = !show" to="/about">About</router-link>
            </div>
        </div>
        <div id="logo">
            <h5 v-bind:class="{show:show}">pat quigley</h5>
            <div id="menu-btn" v-on:click="show = !show" v-bind:class="{show:show}">
                <svg version="1.2" baseProfile="tiny" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px" y="0px" viewBox="0 0 50 50" xml:space="preserve">
                    <line class="line line1" fill="none" stroke="currentColor" stroke-width="5" stroke-dasharray="50" stroke-miterlimit="10" x1="0" y1="5" x2="50" y2="5"/>
                    <line class="line line2" fill="none" stroke="currentColor" stroke-width="5" stroke-dasharray="50" stroke-dashoffset="10" stroke-miterlimit="10" x1="0" y1="25" x2="50" y2="25"/>
                    <line class="line line3" fill="none" stroke="currentColor" stroke-width="5" stroke-dasharray="50" stroke-miterlimit="10" x1="0" y1="45" x2="50" y2="45"/>
                </svg>
            </div>
        </div>
    </div>
</template>

<script> 
export default {
    name: 'NavMenu',
    data () { 
        return { 
            show: false
            } 
        } 
    }
</script>

<style scoped>
#logo {
  display:flex;
  flex-direction: row;
  align-items: center;
  position: fixed;
  top:50px;
  left:50px;
  color:var(--sec-c);
}

#logo * {
    display:inline-block;
}

#logo h5 {
    margin:0 10px 0 0;
    font-size:22px;
    font-weight:400;
    mix-blend-mode: difference;
}

#logo h5.show {
    color:#fff;
}

#menu-btn {
    cursor: pointer;
}

#menu-btn svg {
  height:22px;
  width:22px;
}

#menu-btn:hover svg .line2 {
  stroke-dashoffset: 0;
}

#menu-btn:active svg .line {
  stroke-dashoffset: 50;
}

#menu-btn.show .line1 {
    -webkit-transform: rotate(45deg) translate(20px,0px);
    transform: rotate(45deg) translate(14px,0px);  
}

#menu-btn.show .line2 {
    opacity:0; 
}

#menu-btn.show .line3 {
    -webkit-transform: rotate(-45deg) translate(-20px,0px);
    transform: rotate(-45deg) translate(-32px,-5px);
}

#menu-btn.show svg .line {
  stroke:#fff;
}

#nav .nav-wrap {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    padding: 30px;
    background-color: var(--acc-c);
    color: var(--sec-c);
    transform: translate(-100%,0);
}

#nav .nav-wrap.show {
    transform: translate(0,0);
}

#nav .nav-wrap a {
  color: var(--sec-c);
  opacity:0.6;
}

#nav .nav-wrap a:hover {
  opacity:1;
}

#nav .nav-wrap a.router-link-exact-active {
  color: var(--sec-c);
  opacity:1;
}
</style>
